import { render, staticRenderFns } from "./Aprovadas.vue?vue&type=template&id=0905cccf"
import script from "./Aprovadas.vue?vue&type=script&lang=js"
export * from "./Aprovadas.vue?vue&type=script&lang=js"
import style0 from "./Aprovadas.vue?vue&type=style&index=0&id=0905cccf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports